import { render, staticRenderFns } from "./target.vue?vue&type=template&id=23588508&scoped=true"
import script from "./target.vue?vue&type=script&lang=js"
export * from "./target.vue?vue&type=script&lang=js"
import style0 from "./target.vue?vue&type=style&index=0&id=23588508&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23588508",
  null
  
)

export default component.exports